import { NodeData } from '../modules/api/types/NodeData';
import { Entity } from './Entity';

export class Node<T> extends Entity<T & NodeData> {
    public get nid(): number {
        return this._rawData.nid[0].value;
    }

    public get title(): string {
        return this._rawData.title[0].value;
    }

    public get path(): string {
        return this._rawData.path[0].alias;
    }
}
